import { render, staticRenderFns } from "./IconVideos.vue?vue&type=template&id=ecc3e7a2&"
import script from "./IconVideos.vue?vue&type=script&lang=ts&"
export * from "./IconVideos.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports